import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { FormLabel } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { X } from "lucide-react";
import type { PartnerFormData } from "../types";

interface InlinePartnerFormProps {
  formData: PartnerFormData;
  onChange: (data: PartnerFormData) => void;
  onSubmit: () => void;
  onCancel: () => void;
  isSubmitting: boolean;
}

export function InlinePartnerForm({
  formData,
  onChange,
  onSubmit,
  onCancel,
  isSubmitting,
}: InlinePartnerFormProps) {
  return (
    <div className="space-y-4 border rounded-lg p-4 bg-muted/50">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold">Luo uusi kumppani</h3>
        <Button type="button" variant="ghost" size="sm" onClick={onCancel}>
          <X className="h-4 w-4" />
        </Button>
      </div>

      <div className="space-y-4">
        <div>
          <FormLabel>Kumppanityyppi *</FormLabel>
          <Select
            value={formData.type}
            onValueChange={(value: "installer" | "workshop") =>
              onChange({ ...formData, type: value })
            }
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="installer">Asentaja</SelectItem>
              <SelectItem value="workshop">Työpaja</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div>
          <FormLabel>Nimi *</FormLabel>
          <Input
            value={formData.name}
            onChange={(e) => onChange({ ...formData, name: e.target.value })}
          />
        </div>

        <div>
          <FormLabel>Y-tunnus</FormLabel>
          <Input
            value={formData.business_id}
            onChange={(e) => onChange({ ...formData, business_id: e.target.value })}
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <FormLabel>Sähköposti</FormLabel>
            <Input
              type="email"
              value={formData.email}
              onChange={(e) => onChange({ ...formData, email: e.target.value })}
            />
          </div>
          <div>
            <FormLabel>Puhelin</FormLabel>
            <Input
              value={formData.phone}
              onChange={(e) => onChange({ ...formData, phone: e.target.value })}
            />
          </div>
        </div>

        <div>
          <FormLabel>Osoite</FormLabel>
          <Input
            value={formData.address}
            onChange={(e) => onChange({ ...formData, address: e.target.value })}
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <FormLabel>Postinumero</FormLabel>
            <Input
              value={formData.postal_code}
              onChange={(e) => onChange({ ...formData, postal_code: e.target.value })}
            />
          </div>
          <div>
            <FormLabel>Kaupunki</FormLabel>
            <Input
              value={formData.city}
              onChange={(e) => onChange({ ...formData, city: e.target.value })}
            />
          </div>
        </div>
      </div>

      <div className="flex justify-end gap-2">
        <Button type="button" variant="outline" onClick={onCancel}>
          Peruuta
        </Button>
        <Button type="button" onClick={onSubmit} disabled={isSubmitting}>
          {isSubmitting ? "Luodaan..." : "Tallenna kumppani"}
        </Button>
      </div>
    </div>
  );
}
